import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import file from "../../../../assets/svg/File.svg";
import category from "../../../../assets/svg/category.svg";
import role from "../../../../assets/svg/role.svg";
import note from "../../../../assets/svg/note.svg";
import dateIcon from "../../../../assets/svg/calendar-inside.svg";
import moment from "moment";
import calender from "../../../../assets/svg/calender.svg";
import infoBlack from "../../../../assets/svg/infoBlack.svg";
import submit from "../../../../assets/svg/submit.svg";
import $, { data } from "jquery";
import Autocomplete from "react-autocomplete";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import "date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import Icon from "@material-ui/core/Icon";
import DateFnsUtils from "@date-io/date-fns";
import { rightBarClose } from "../../../../redux/action/Action";
import {
  GET_ALL_USERS,
  GET_CATAGORY_DROPDOWN,
  POST_CATEGORIES,
  POST_NEW_DOCUMENT,
  POST_REGISTER_DOCUMENT,
  GET_NOTIFICATION_COUNT,
} from "../../../../helpers/endpointService";
import axios from "axios";
import { PulseLoader } from "react-spinners";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Loader, logoutFunction, CheckPasswordValid } from "../../../custom/commonFunction";
import lock from "../../../../assets/svg/lock.svg";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import FilledInput from "@mui/material/FilledInput";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const useStyles = makeStyles((theme) => ({
  inputfieldAlign: {
    "& fieldset": {
      top: "-1px !important",
    },
  },
  button: {
    background: "#FFFFFF",
    border: "none",
    boxSizing: "border-box",
    paddingLeft: "11px",
    paddingRight: "20px",
  },
}));
var days = 1;

var SelectedValue1 = false;
var SelectedValue2 = false;

export default function NewDocument({ rightbarOpen }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const userId = localStorage.getItem("UserId");
  const [isPropertyLoader, setPropertyLoader] = useState(true);
  const [isUserLoader, setIsUserLoader] = useState(true);
  const [isPropertyFailed, setPropertyFailed] = useState(false);
  const [category1Default, setCategory1Default] = useState();
  const [category2Default, setCategory2Default] = useState();
  const [docNo, setDocNo] = useState();
  const [sumbitOne, setSubmitOne] = useState(true);

  const [category2Change, setcategory2Change] = useState(false);

  const [category1, setCategory1] = useState("");
  const [category2, setCategory2] = useState("");
  const [category1Id, setCategory1Id] = useState(0);
  const [category2Id, setCategory2Id] = useState(0);
  const [users, setUsers] = useState([]);
  const [today, setToday] = useState(() => {
    const today = new Date();
    today?.setDate(today.getDate() + 1);
    return today?.toISOString().split("T")[0];
  });

  const [UserArrayList, setUserArrayList] = useState([]);
  const [AdminArrayList, setAdminArrayList] = useState([]);
  const [AuthorArrayList, setAuthorArrayList] = useState([]);
  const [Approver1ArrayList, setApprover1ArrayList] = useState([]);
  const [Approver2ArrayList, setApprover2ArrayList] = useState([]);
  const [Checker1ArrayList, setChecker1ArrayList] = useState([]);
  const [Checker2ArrayList, setChecker2ArrayList] = useState([]);
  const [Consultant1ArrayList, setConsultant1ArrayList] = useState([]);
  const [Consultant2ArrayList, setConsultant2ArrayList] = useState([]);

  const [category1Error, setCategory1Error] = useState(false);
  const [category2Error, setCategory2Error] = useState(false);
  const [authorError, setAuthorError] = useState(false);
  const [checker1Error, setChecker1Error] = useState(false);
  const [approver1Error, setApprover1Error] = useState(false);
  const [valueChanged, setValueChanged] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [isDocumentNameError, setIsDocumentNameError] = useState(false);
  const [isDocumentNoError, setIsDocumentNoError] = useState(false);
  const [isMobile, setisMobile] = useState(false);

  const [newPasswordValue, setNewPasswordValue] = useState("");
  const [confirmPasswordValue, setConfirmPasswordValue] = useState("");
  const [isPasswordProtected, setIsPasswordProtected] = useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const [inputData, setInputData] = useState({
    id: 0,
    documentName: "",
    revisedDocumentId: 0,
    documentNo: "",
    version: 0,
    category1Name: "",
    category2Name: "",
    category1Id: 0,
    category2Id: 0,
    authorId: 0,
    author: "",
    checker1Id: 0,
    checker2Id: 0,
    checker1: "",
    checker2: "",
    consultant1Id: 0,
    consultant2Id: 0,
    consultant1: "",
    consultant2: "",
    approver1Id: 0,
    approver2Id: 0,
    approver1: "",
    approver2: "",
    documentDate: "",
    createdDate: "",
    documentStatus: "",
    approvalStatus: "",
    reviewDate: "",
    remarks: "",
    reason: "",
  });

  const close = () => {
    dispatch(rightBarClose());
    $("body").removeClass("scrollhide");
  };

  useEffect(() => {
    setIsUserLoader(true);
    setPropertyLoader(true);
    setPropertyFailed(false);
    if (rightbarOpen) {
      $("body").addClass("scrollhide");
    }
    // fetchReviewers();
    const fetchAdminUsers = () => {
      let reviewerApiUrl = `${GET_ALL_USERS}?includeAdmin=true`;
      // await
      axios
        .get(reviewerApiUrl)
        .then((response) => {
          if (response?.status === 200) {
            setAdminArrayList(
              response.data?.map((res) => {
                return {
                  value: res.id,
                  label: res.userName,
                };
              })
            );
            setIsUserLoader(false);
          } else {
          }
          setIsUserLoader(false);
        })
        .catch((err) => {
          setIsUserLoader(false);
          logoutFunction(err?.response?.status);
        });
    };
    fetchAdminUsers();
    const fetchCategory1Data = async () => {
      let propApiUrl = `${GET_CATAGORY_DROPDOWN}?type=category1&isLedger=false`;
      await axios
        .get(propApiUrl)
        .then((response) => {
          setPropertyLoader(false);
          if (response?.status === 200) {
            setPropertyFailed(false);
            setCategory1Default(
              response.data?.map((res) => {
                return {
                  value: res.categoryId,
                  label: res.categoryName,
                };
              })
            );
          }
        })
        .catch((err) => {
          setPropertyLoader(false);
          setPropertyFailed(true);
          logoutFunction(err?.response?.status);
        });
    };
    fetchCategory1Data();

    ////////////////// Fetch Reviewers ///////////////////////
    // Commented for CR7 - Admin can be checker/consultant/approver
    // const fetchReviewers = async () => {
    //   let reviewerApiUrl = `${GET_ALL_USERS}?`;
    //   await axios
    //     .get(reviewerApiUrl)
    //     .then((response) => {
    //       if (response?.status === 200) {
    //         setUsers(response.data);
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       logoutFunction(err?.response?.status);
    //     });
    // };
  }, []);

  // useEffect(() => {
  //   let usersOption = users?.map((user) => {
  //     return {
  //       value: user.id,
  //       label: user.userName,
  //     };
  //   });
  //   setUserArrayList(usersOption);
  //   setApprover1ArrayList(usersOption);
  //   setApprover2ArrayList(usersOption);
  //   setChecker1ArrayList(usersOption);
  //   setChecker2ArrayList(usersOption);
  //   setConsultant1ArrayList(usersOption);
  //   setConsultant2ArrayList(usersOption);
  // }, [users]);

  useEffect(() => {
    // setAuthorArrayList(AdminArrayList);
    // setUserArrayList(AdminArrayList);
    // setApprover1ArrayList(AdminArrayList);
    // setApprover2ArrayList(AdminArrayList);
    // setChecker1ArrayList(AdminArrayList);
    // setChecker2ArrayList(AdminArrayList);
    // setConsultant1ArrayList(AdminArrayList);
    // setConsultant2ArrayList(AdminArrayList);
    GetDropdownList();
  }, [AdminArrayList]);
  useEffect(() => {}, [Consultant1ArrayList]);

  /////////////////////////////////////// Fetch document number /////////////////////////////////////
  const fetchDocumentNo = async () => {
    axios({
      method: "POST",
      url: POST_NEW_DOCUMENT,
      data: {
        id: 0,
        category1Name: "",
        category2Name: "",
        category1Id: parseInt(category1?.value),
        category2Id: parseInt(category2.value),
        documentId: 0,
        documentFormat: "",
        numberFormat: "",
      },
    })
      .then((response) => {
        setPropertyLoader(false);
        if (response?.status === 200) {
          setDocNo(response.data);
          if (
            response.data?.documentFormat === null &&
            response.data?.numberFormat === null
          ) {
            toast.warning("Ledger is not created for this category", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "colored",
            });
          }
        }
      })
      .catch((err) => {
        setDocNo("");
        logoutFunction(err?.response?.status);
      });
  };

  const fetchCategory2Data = async (id) => {
    let category2ApiUrl = `${POST_CATEGORIES}?category1Id=${id}`;

    axios({
      method: "POST",
      url: category2ApiUrl,
      data: null,
    })
      .then((response) => {
        setPropertyLoader(false);
        if (response?.status === 200) {
          setCategory2Default(
            response.data?.map((res) => {
              return {
                label: res.category2Name,
                value: res.category2Id,
              };
            })
          );
        }
      })
      .catch((err) => {
        logoutFunction(err?.response?.status);
      });
  };

  useEffect(() => {
    // if (category1) {
    setCategory2Default([]);
    setCategory2("");
    // }
  }, [category1]);

  useEffect(() => {
    if (category1 && category2) {
      fetchDocumentNo();
    } else {
      setDocNo("");
    }
  }, [category2Change]);

  ///////////////////////////////////////////// Submit Document ///////////////////////////////////////////

  const submitNewDocument = () => {
    if (sumbitOne === true) {
      setSubmitOne(false);
      const inputs = document.querySelectorAll(".my-input-class[required]");
      const isValid = Array.from(inputs).every((input) => input.value !== "");

      const removeBorderInputs = Array.from(inputs).filter(
        (input) => input.value != ""
      );

      removeBorderInputs?.forEach((input) => {
        input.style.borderColor = "";
      });

      const inputs1 = document.querySelectorAll(".resubmit-autocomplete");
      const isValid1 = Array.from(inputs1).every((input) => input.value !== "");

      const category1Empty = !category1 || category1 === null;
      const category2Empty = !category2 || category2 === null;
      const authorEmpty = !inputData.author || inputData.author === null;
      const checker1Empty = !inputData.checker1 || inputData.checker1 === null;
      const approver1Empty =
        !inputData.approver1 || inputData.approver1 === null;

      setCategory1Error(category1Empty);
      setCategory2Error(category2Empty);
      setAuthorError(authorEmpty);
      setChecker1Error(checker1Empty);
      setApprover1Error(approver1Empty);

      const removeBorder = Array.from(inputs1).filter(
        (input) => input.value != ""
      );

      removeBorder?.forEach((input) => {
        input.style.borderColor = "";
      });

      let myDateUTC;
      if (inputData.reviewDate) {
        let current = new Date();
        let h = current.getHours();
        let m = current.getMinutes();
        let s = current.getSeconds();
        let formattedTime = `${h.toString().padStart(2, "0")}:${m
          .toString()
          .padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
        let Newdate = moment(inputData.reviewDate).format("YYYY-MM-DD");
        var dataDate = Newdate;
        myDateUTC = dataDate;
        /* let formattedTime = `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
        let Newdate=moment(inputData.reviewDate).format("DD-MM-YYYY")
        var myDate = Newdate + "T" + formattedTime;
         */
        /*  myDateUTC = new Date(myDate).toISOString(); */
      }
      const checkPassword = CheckPasswordValid(isPasswordProtected, newPasswordValue, confirmPasswordValue);
      if (
        isValid &&
        docNo?.numberFormat !== null &&
        isValid1 &&
        !category1Empty &&
        !category2Empty &&
        !authorEmpty &&
        !checker1Empty &&
        !approver1Empty &&
        !isDocumentNameError &&
        checkPassword
      ) {
        setPropertyLoader(true);
        const newDocumentDetails = {
          id: 0,
          documentName: inputData.docName,
          revisedDocumentId: 0,
          documentNo: docNo?.numberFormat,
          version: null,
          category1Name: category1?.label || null,
          category2Name: category2?.label || null,
          category1Id: parseInt(category1?.value) || 0,
          category2Id: parseInt(category2?.value) || 0,
          authorId: parseInt(inputData.author?.value) || 0,
          authorName: inputData.author?.label || null,
          checker1Id: parseInt(inputData.checker1?.value) || 0,
          checker2Id: parseInt(inputData.checker2?.value) || 0,
          checker1Name: inputData.checker1?.label || null,
          checker2Name: inputData.checker2?.label || null,
          consultant1Id: parseInt(inputData.consultant1?.value) || 0,
          consultant2Id: parseInt(inputData.consultant2?.value) || 0,
          consultant1Name: inputData.consultant1?.label || null,
          consultant2Name: inputData.consultant2?.label || null,
          approver1Id: parseInt(inputData.approver1?.value) || 0,
          approver2Id: parseInt(inputData.approver2?.value) || 0,
          approver1Name: inputData.approver1?.label || null,
          approver2Name: inputData.approver2?.label || null,
          documentDate: null,
          documentStatus: null,
          approvalStatus: null,
          reviewDate: myDateUTC || null,
          remarks: inputData.remarks,
          reason: null,
          isPasswordProtected: isPasswordProtected,
          password:
            isPasswordProtected == true ? window.btoa(newPasswordValue) : "",
        };
        // console.log(newDocumentDetails, "newDocumentDetails");
        let apiUrl = `${POST_REGISTER_DOCUMENT}?userId=${userId}`;
        axios({
          method: "POST",
          url: apiUrl,
          data: newDocumentDetails,
        })
          .then((response) => {
            setPropertyLoader(false);
            dispatch(rightBarClose());
            if (response?.status === 200) {
              setSubmitOne(true);
              if (response.data == "success") {
                if (userId) {
                  let apiUrl1 = `${GET_NOTIFICATION_COUNT}?userId=${userId}`;
                  axios({
                    method: "GET",
                    url: apiUrl1,
                  })
                    .then((res) => {
                      if (res?.status === 200) {
                        dispatch({ type: "NOTIFICATIONCOUNT", data: res.data });
                      }
                    })
                    .catch((err) => {});
                }

                toast.success("Document registered successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "colored",
                });
              } else if (response.data == "document is already registered") {
                toast.warning("Document is already registered", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "colored",
                });
              }
              dispatch(rightBarClose());
              $("body").removeClass("scrollhide");
            }
          })
          .catch((err) => {
            setSubmitOne(true);
            dispatch(rightBarClose());
            setPropertyLoader(false);

            logoutFunction(err?.response?.status);
          });
      } else {
        setSubmitOne(true);
        // console.log(checkPassword, "newDocumentDetailsError");
      }

      const viewbar = document.getElementById("viewbar");

      if (docNo?.numberFormat === null) {
        document.getElementById("dno").style.borderBottom = "1px solid red";
        toast.warning("Ledger is not created for this category", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "colored",
        });

        //document.getElementById("dno").style.height = "70px";
        viewbar.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
        // if (isMobile) {
        //   document.getElementById("dno").style.height = "50px";
        // }
        setIsDocumentNoError(true);
      } else {
        document.getElementById("dno").style.borderBottom = "none";
      }
      const emptyInputs = Array.from(inputs).filter(
        (input) => input.value === ""
      );
      const emptyInputs1 = Array.from(inputs1).filter(
        (input) => input.value === ""
      );
      if (emptyInputs?.length > 0) {
        viewbar.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });

        emptyInputs.forEach((input) => {
          input.style.borderColor = "red";

          input.addEventListener("input", () => {
            if (input.value !== "") {
              input.style.borderColor = "";
            }
          });
        });
      }

      if (emptyInputs1?.length > 0) {
        viewbar.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });

        emptyInputs1?.forEach((input) => {
          input.style.borderColor = "red";

          input.addEventListener("input", () => {
            if (input.value !== "") {
              input.style.borderColor = "";
            }
          });
        });
      }
    }
  };

  ///////////////////////////////////////////// Handle input change //////////////////////////////////////////////

  useEffect(() => {
    GetDropdownList();
  }, [valueChanged]);

  useEffect(() => {
    const intervals = setInterval(() => {
      resize();
    }, 10);
    return () => clearInterval(intervals);
  }, []);

  const resize = () => {
    if (window.innerWidth < 850) {
      setisMobile(true);
    } else {
      setisMobile(false);
    }
  };

  const handleSelectChange = (value, field) => {
    SelectedValue1 = true;
    setInputData((prevData) => ({
      ...prevData,
      [field]: value,
    }));

    setValueChanged(!valueChanged);
  };

  const GetDropdownList = () => {
    const {
      author,
      approver1,
      approver2,
      checker1,
      checker2,
      consultant1,
      consultant2,
    } = inputData;

    // const Array1 = UserArrayList;
    const Array2 = AdminArrayList;
    const SelectedValues = [];
    const AuthorValue = [];
    const Checker1Value = [];
    const Checker2Value = [];
    const Consultant1Value = [];
    const Consultant2Value = [];
    const Approver1Value = [];
    const Approver2Value = [];
    // let FilterArray = UserArrayList;
    let NewFilterArray = AdminArrayList;
    const ArrayResult = [
      author,
      approver1,
      approver2,
      checker1,
      checker2,
      consultant1,
      consultant2,
    ];

    ArrayResult.forEach((j) => {
      if (j) {
        SelectedValues.push(j.value); // Store the selected values
      }
    });

    // FilterArray = FilterArray.filter(
    //   (item) => !SelectedValues.includes(item.value)
    // );
    NewFilterArray = NewFilterArray.filter(
      (item) => !SelectedValues.includes(item.value)
    );

    AuthorValue.push(...Array2.filter((item) => item.value === author));
    Checker1Value.push(...Array2.filter((item) => item.value === checker1));
    Checker2Value.push(...Array2.filter((item) => item.value === checker2));
    Consultant1Value.push(
      ...Array2.filter((item) => item.value === consultant1)
    );
    Consultant2Value.push(
      ...Array2.filter((item) => item.value === consultant2)
    );
    Approver1Value.push(...Array2.filter((item) => item.value === approver1));
    Approver2Value.push(...Array2.filter((item) => item.value === approver2));

    const FinalAuthorResult = [...AuthorValue, ...NewFilterArray];
    const FinalApprover1Result = [...Approver1Value, ...NewFilterArray];
    const FinalApprover2Result = [...Approver2Value, ...NewFilterArray];
    const FinalChecker1Result = [...Checker1Value, ...NewFilterArray];
    const FinalChecker2Result = [...Checker2Value, ...NewFilterArray];
    const FinalConsultant1Result = [...Consultant1Value, ...NewFilterArray];
    const FinalConsultant2Result = [...Consultant2Value, ...NewFilterArray];

    setAuthorArrayList(FinalAuthorResult);
    setApprover1ArrayList(FinalApprover1Result);
    setApprover2ArrayList(FinalApprover2Result);
    setChecker1ArrayList(FinalChecker1Result);
    setChecker2ArrayList(FinalChecker2Result);
    setConsultant1ArrayList(FinalConsultant1Result);
    setConsultant2ArrayList(FinalConsultant2Result);
  };

  const handleChange = (e, field) => {
    if (field === "reviewDate") {
      const inputDate = e;
      const formattedDate = inputDate
        ? moment(inputDate).format("DD-MMM-YYYY")
        : "";
      setInputData((prevData) => ({
        ...prevData,
        ["reviewDate"]: inputDate,
      }));
    } else if (field === "documentName") {
      const { name, value } = e.target;
      if (value.length <= 255) {
        setIsDocumentNameError(false);
        setInputData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      } else {
        setIsDocumentNameError(true);
      }
    } else {
      const { name, value } = e.target;
      setInputData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  //////////////////////////////   OnBlur   //////////////////////////////////

  // const handleBlur = () => {
  //   const timer = setTimeout(() => {
  //     if (SelectedValue1 === false) {
  //       if (inputData.approver1 !== "" && inputData.approver1Id === 0) {
  //         setInputData((prevData) => ({
  //           ...prevData,
  //           approver1: ""
  //         }));
  //       }
  //       if (inputData.approver2 !== "" && inputData.approver2Id === 0) {
  //         setInputData((prevData) => ({
  //           ...prevData,
  //           approver2: ""
  //         }));
  //       }
  //       if (inputData.consultant1 !== "" && inputData.consultant1Id === 0) {
  //         setInputData((prevData) => ({
  //           ...prevData,
  //           consultant1: ""
  //         }));
  //       }
  //       if (inputData.consultant2 !== "" && inputData.consultant2Id === 0) {
  //         setInputData((prevData) => ({
  //           ...prevData,
  //           consultant2: ""
  //         }));
  //       }
  //       if (inputData.checker1 !== "" && inputData.checker1Id === 0) {
  //         setInputData((prevData) => ({
  //           ...prevData,
  //           checker1: ""
  //         }));
  //       }
  //       if (inputData.checker2 !== "" && inputData.checker2Id === 0) {
  //         setInputData((prevData) => ({
  //           ...prevData,
  //           checker2: ""
  //         }));
  //       }
  //       if (inputData.author !== "" && inputData.authorId === 0) {
  //         setInputData((prevData) => ({
  //           ...prevData,
  //           author: ""
  //         }));
  //       }
  //       setValueChanged(!valueChanged)
  //     }
  //   }, 500);
  // };

  const handleCategoryInputChange = (e, field) => {
    SelectedValue2 = false;
    // if (e === "") {
    if (field === "category1Name") {
      setCategory1(e);
      setCategory2("");
    } else if (field === "category2Name") {
      setCategory2(e);
      setCategory2Id(0);
    }
    // }
    // else {
    //   if (field === "category1Name") {
    //     setCategory1Id(0);
    //   } else if (field === "category2Name") {
    //     setCategory2(e);
    //     setCategory2Id(0);
    //   }
    // }
  };

  // const handleBlurcategory = () => {
  //   const timer = setTimeout(() => {
  //     if (SelectedValue2 === false) {
  //       if (category1 !== "" && category1Id === 0) {
  //         setCategory1("");
  //         setCategory2("");
  //       } if (category2 !== "" && category2Id === 0) {
  //         setCategory2("")
  //       }
  //     }
  //   }, 500);
  // }

  const handleSelectCategoryChange = (value, field) => {
    SelectedValue2 = true;
    if (field === "category1Name") {
      setPropertyLoader(true);
      setPropertyFailed(false);
      setCategory1(value);
      fetchCategory2Data(value?.value);
      setCategory2("");
      setCategory2Id(0);
      setPropertyLoader(false);
      setcategory2Change(!category2Change);
      setPropertyFailed(false);
    } else if (field === "category2Name") {
      setcategory2Change(!category2Change);
      setCategory2(value);
    }
  };

  const handleCheckboxChange = (event) => {
    setIsPasswordProtected(event.target.checked);
  };

  const handleClickShowNewPassword = () => setShowNewPassword((show) => !show);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);

  return (
    <>
      <Loader isAppLoader={isPropertyLoader || isUserLoader ? true : false} />
      <div
        id="viewbar"
        className={`viewbar newDocument ${rightbarOpen ? "viewbarOpen" : ""} ${
          isPropertyLoader || isUserLoader ? "overFlowHidden" : ""
        }`}
      >
        {/* {isPropertyLoader || isUserLoader && (
          <div className="spinner_overlay-new">
            <div className="loader-new">
              <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
            </div>
          </div>
        )} */}

        {isPropertyFailed && (
          <div className="spinner_overlay-new">
            <div className="loader-new">
              <span>Loading failed</span>
            </div>
          </div>
        )}

        <div className="viewMain">
          <div className="viewTitle d-flex align-items-center">
            <span>Register new document</span>
            {!isPropertyLoader && (
              <span className="close mt-1" onClick={close}>
                ✕
              </span>
            )}
          </div>
          {category1Default && (
            <div className="common-margin-bottom">
              <div className="row">
                <div className={`col-sm-6 col-12 mt-2`}>
                  <div className="inputTitle mt-2 commonsearch-field">
                    <img src={role} alt="" />
                    <span>
                      {" "}
                      Category 1&nbsp;
                      <span style={{ color: "#ee192d" }}>*</span>
                    </span>
                  </div>
                  <div className="mt-1">
                    <Select
                      className={`text-12-normal ${
                        category1Error ? "error" : ""
                      }`}
                      classNamePrefix="assigngroups"
                      value={category1}
                      options={category1Default}
                      defaultValue={category1 || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) =>
                        handleSelectCategoryChange(e, "category1Name")
                      }
                    />
                  </div>
                </div>

                <div className={`col-sm-6 col-12 mt-2`}>
                  <div className="inputTitle mt-2 commonsearch-field">
                    <img src={role} alt="" />
                    <span>
                      {" "}
                      Category 2&nbsp;
                      <span style={{ color: "#ee192d" }}>*</span>
                    </span>
                  </div>
                  <div className="mt-1">
                    <Select
                      className={`text-12-normal ${
                        category2Error ? "error" : ""
                      }`}
                      classNamePrefix="assigngroups"
                      value={category2}
                      isDisabled={!category1}
                      options={category2Default}
                      defaultValue={category2 || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) =>
                        handleSelectCategoryChange(e, "category2Name")
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div
                  className="col-sm-6 col-12 d-flex flex-column mb-1"
                  id="dno"
                >
                  <div className="inputTitle commonsearch-field">
                    <span>
                      <img
                        style={{ position: "relative", top: "-1px" }}
                        src={infoBlack}
                        alt=""
                      />{" "}
                      Document no.
                    </span>
                  </div>
                  <span
                    className="mt-1"
                    style={{
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "#605E5C",
                      paddingLeft: "2px",
                    }}
                  >
                    {docNo?.documentFormat && docNo?.numberFormat? docNo?.documentFormat+docNo?.numberFormat:"-"}
                    {/* {docNo?.documentFormat || "-"}
                    {docNo?.numberFormat || "-"} */}
                  </span>
                </div>
                {/* {isMobile && (
                  <>
                    {isDocumentNoError && (
                      <span
                        className="Error-msg pb-2"
                        style={{ display: "inline-block", width: "230px" }}
                      >
                        ledger is not created for this category
                      </span>
                    )}
                  </>
                )} */}
                <div className="col-sm-6 col-12 topfield">
                  <div className="inputTitle commonsearch-field">
                    <img src={file} alt="" />
                    <span>
                      {" "}
                      Document name&nbsp;
                      <span style={{ color: "#ee192d" }}>*</span>
                    </span>
                  </div>
                  <input
                    style={{ fontSize: "12px" }}
                    name="docName"
                    value={inputData.docName}
                    maxLength={255}
                    onChange={(e) => handleChange(e, "documentName")}
                    className="form-control my-input-class border-radius shiptype-select mt-2 dropdown-height"
                    required
                  />
                  {isDocumentNameError && (
                    <span className="Error-msg">
                      Document name must be less than 255 characters
                    </span>
                  )}
                </div>
              </div>
              {/* {!isMobile && (
                <>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      {isDocumentNoError && (
                        <span className="Error-msg">
                          ledger is not created for this category
                        </span>
                      )}
                    </div>
                  </div>
                </>
              )} */}

              <div className="row mt-2">
                <div className={`col-sm-6 col-12`}>
                  <div className="inputTitle mt-2 commonsearch-field">
                    <img src={role} alt="" />
                    <span>
                      {" "}
                      Author&nbsp;<span style={{ color: "#ee192d" }}>*</span>
                    </span>
                  </div>
                  <div className="mt-1">
                    <Select
                      className={`text-12-normal ${authorError ? "error" : ""}`}
                      classNamePrefix="assigngroups"
                      value={inputData.author}
                      options={AuthorArrayList}
                      defaultValue={inputData.author || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) => handleSelectChange(e, "author")}
                    />
                  </div>
                </div>

                <div className={`col-sm-6 col-12 topfield`}>
                  <div className="inputTitle mt-2 commonsearch-field">
                    <img src={role} alt="" />
                    <span>
                      {" "}
                      Checker 1&nbsp;<span style={{ color: "#ee192d" }}>*</span>
                    </span>
                  </div>
                  <div className="mt-1">
                    <Select
                      className={`text-12-normal ${
                        checker1Error ? "error" : ""
                      }`}
                      classNamePrefix="assigngroups"
                      value={inputData.checker1}
                      options={Checker1ArrayList}
                      defaultValue={inputData.checker1 || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) => handleSelectChange(e, "checker1")}
                    />
                  </div>
                </div>
              </div>

              <div className="row mt-2">
                <div className={`col-sm-6 col-12`}>
                  <div className="inputTitle mt-2 commonsearch-field">
                    <img src={role} alt="" />
                    <span> Checker 2</span>
                  </div>
                  <div className="mt-1">
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={inputData.checker2}
                      options={Checker2ArrayList}
                      defaultValue={inputData.checker2 || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) => handleSelectChange(e, "checker2")}
                    />
                  </div>
                </div>

                <div className={`col-sm-6 col-12 topfield`}>
                  <div className="inputTitle mt-2 commonsearch-field">
                    <img src={role} alt="" />
                    <span> Consultant 1</span>
                  </div>
                  <div className="mt-1">
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={inputData.consultant1}
                      options={Consultant1ArrayList}
                      defaultValue={inputData.consultant1 || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) => handleSelectChange(e, "consultant1")}
                    />
                  </div>
                </div>
              </div>

              <div className="row mt-2">
                <div className={`col-sm-6 col-12`}>
                  <div className="inputTitle mt-2 commonsearch-field">
                    <img src={role} alt="" />
                    <span> Consultant 2</span>
                  </div>
                  <div className="mt-1">
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={inputData.consultant2}
                      options={Consultant2ArrayList}
                      defaultValue={inputData.consultant2 || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) => handleSelectChange(e, "consultant2")}
                    />
                  </div>
                </div>

                <div className={`col-sm-6 col-12 topfield`}>
                  <div className="inputTitle mt-2 commonsearch-field">
                    <img src={role} alt="" />
                    <span>
                      {" "}
                      Approver 1&nbsp;
                      <span style={{ color: "#ee192d" }}>*</span>
                    </span>
                  </div>
                  <div className="mt-1">
                    <Select
                      className={`text-12-normal ${
                        approver1Error ? "error" : ""
                      }`}
                      classNamePrefix="assigngroups"
                      value={inputData.approver1}
                      options={Approver1ArrayList}
                      defaultValue={inputData.approver1 || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) => handleSelectChange(e, "approver1")}
                    />
                  </div>
                </div>
              </div>

              <div className="row mt-2">
                <div className={`col-sm-6 col-12`}>
                  <div className="inputTitle mt-2 commonsearch-field">
                    <img src={role} alt="" />
                    <span> Approver 2</span>
                  </div>
                  <div className="mt-1">
                    <Select
                      className="text-12-normal"
                      classNamePrefix="assigngroups"
                      value={inputData.approver2}
                      options={Approver2ArrayList}
                      defaultValue={inputData.approver2 || "Select"}
                      isMulti={false}
                      isSearchable={true}
                      isClearable={true}
                      onChange={(e) => handleSelectChange(e, "approver2")}
                    />
                  </div>
                </div>

                <div className="col-sm-6 col-12 topfield">
                  <div className="inputTitle date-bottom mt-2 commonsearch-field">
                    <img src={calender} alt="" />
                    <span style={{marginBottom: "2px"}}> Expiry date</span>
                  </div>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      className="form-control expiry-date-margin"
                      emptyLabel="dd-mmm-yyyy"
                      keyboardIcon={<img src={dateIcon} />}
                      minDate={new Date(
                        Date.now() + days * 24 * 60 * 60 * 1000
                      ).toString()}
                      format="dd-MMM-yyyy"
                      value={inputData.reviewDate ? inputData.reviewDate : null}
                      size="small"
                      onChange={(e) => handleChange(e, "reviewDate")}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>

              <div className="row">
                <div className="col-12 mt-3">
                  <div className="inputTitle commonsearch-field">
                    <img src={note} alt="" />
                    <span>Note</span>
                  </div>
                  <textarea
                    value={inputData.remarks}
                    name="remarks"
                    onChange={(e) => handleChange(e)}
                    className="form-control border-radius remarks shiptype-select mt-2"
                    style={{
                      width: "100%",
                      height: "70px",
                      fontSize: "12px",
                      maxHeight: "70px",
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 mt-3">
                  <div className="inputTitle commonsearch-field">
                    <input
                      type="checkbox"
                      className="password-checkbox"
                      name="request"
                      onChange={(e) => handleCheckboxChange(e)}
                    />
                    <span className="password-text">
                      Is password protected?
                    </span>
                  </div>
                </div>
              </div>
              {isPasswordProtected && (
                <div className="row">
                  <div className="col-12 mt-3">
                    <div className="inputTitle commonsearch-field">
                      <img src={lock} className="password-icon" alt="" />
                      <span>
                        {" "}
                        New password&nbsp;
                        <span style={{ color: "#ee192d" }}>*</span>
                      </span>
                    </div>
                    <FormControl variant="outlined" className="w-100 mt-2">
                      <OutlinedInput
                        className="password-inputs newdoc-newpassword"
                        id="newdoc-newpasswordid"
                        value={newPasswordValue}
                        onChange={(e) => setNewPasswordValue(e.target.value)}
                        type={showNewPassword ? "text" : "password"}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowNewPassword}
                              edge="end"
                            >
                              {showNewPassword ? (
                                <VisibilityOff className="eye-password-icon" />
                              ) : (
                                <Visibility className="eye-password-icon" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                    <div className="mt-0 font-13">
                      <span
                        className="required-color font-weight400 newPasswordErrorText"
                        id="newPasswordErrorText"
                      ></span>
                    </div>
                  </div>
                  <div className="col-12 mt-3">
                    <div className="inputTitle commonsearch-field">
                      <img src={lock} className="password-icon" alt="" />
                      <span>
                        {" "}
                        Confirm password&nbsp;
                        <span style={{ color: "#ee192d" }}>*</span>
                      </span>
                    </div>
                    <FormControl variant="outlined" className="w-100 mt-2">
                      <OutlinedInput
                        className="password-inputs newdoc-confirmpassword"
                        id="newdoc-confirmpasswordid"
                        value={confirmPasswordValue}
                        onChange={(e) =>
                          setConfirmPasswordValue(e.target.value)
                        }
                        type={showConfirmPassword ? "text" : "password"}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowConfirmPassword}
                              edge="end"
                            >
                              {showConfirmPassword ? (
                                <VisibilityOff className="eye-password-icon" />
                              ) : (
                                <Visibility className="eye-password-icon" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                    <div className="mt-0">
                      <span
                        className="required-color font-weight400 font-13 confirmPasswordErrorText"
                        id="confirmPasswordErrorText"
                      ></span>
                    </div>
                  </div>
                </div>
              )}
              {hasError && (
                <div className="mt-1">
                  <span style={{ color: "red" }}>
                    Input values has duplicates
                  </span>
                </div>
              )}
              <div className="button">
                <button id="edit" onClick={submitNewDocument}>
                  <img
                    style={{
                      marginTop: "-4px",
                      marginRight: "4px",
                      width: "14px",
                    }}
                    src={submit}
                    alt=""
                  />
                  Submit
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
